import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,ViewChild,ElementRef,EventEmitter } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  templateUrl: "./modal.alram.component.html"
  ,styleUrls: ["./modal.alram.component.scss"]
})
export class ModalAlramComponent implements OnInit, OnDestroy, AfterViewInit{
  isContinue:boolean = true;
  @Input() Context:string;

  constructor(
    private modalService: NgbModal
    ,public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.isContinue = false;
  }
  ngAfterViewInit() {
  }

  clickCancel() {
    this.activeModal.close({
      "result":"cancel"
    });
  }

}
